export enum LawsEnum {
  law_19210,
  law_17934,
  law_18083,
  law_18910,
}
